import { useId, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { capacityLabel, count, recommendTier, type BillingCycle } from "./pricing-tiers";

/** Estimation locale : les volumes saisis ne sont ni enregistrés ni transmis. */
export function PlanFinder({ cycle }: { cycle: BillingCycle }) {
  const id = useId();
  const [users, setUsers] = useState("1");
  const [invoices, setInvoices] = useState("25");
  const tier = users.trim() && invoices.trim() ? recommendTier(Number(users), Number(invoices)) : null;
  const price = tier && tier.price !== "custom" ? tier.price[cycle] : null;
  const inputClass = "mt-2 h-11 w-full rounded-lg border border-input bg-surface px-3 text-base text-foreground tabular-nums focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring";
  return (
    <section aria-labelledby={`${id}-title`} className="rounded-panel border border-action-border bg-action-soft p-5 sm:p-6">
      <div className="grid gap-6 lg:grid-cols-[1.05fr_1fr_1.1fr] lg:items-center">
        <div>
          <h2 id={`${id}-title`} className="font-display text-xl font-semibold text-primary">Quelle offre pour votre activité ?</h2>
          <p id={`${id}-hint`} className="mt-2 text-sm leading-relaxed text-muted-foreground">Indiquez votre équipe et votre volume de factures à suivre. Nous cherchons la première offre qui couvre les deux.</p>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <label className="text-ui font-semibold text-foreground">
            Utilisateurs
            <input type="number" inputMode="numeric" min={1} step={1} value={users} onChange={(event) => setUsers(event.target.value)} aria-describedby={`${id}-hint`} className={inputClass} />
          </label>
          <label className="text-ui font-semibold text-foreground">
            Factures actives
            <input type="number" inputMode="numeric" min={0} step={1} value={invoices} onChange={(event) => setInvoices(event.target.value)} aria-describedby={`${id}-hint`} className={inputClass} />
          </label>
        </div>
        <div className="min-h-24 border-t border-action-border pt-4 lg:border-t-0 lg:border-l lg:pt-0 lg:pl-6">
          <div role="status" aria-atomic="true">
            {/* La recommandation arrive quand elle change, pas à chaque frappe. */}
            <div key={tier ? `${tier.id}-${price ?? "devis"}-${cycle}` : "aucune"} className="enc-rise-sm">
            {tier ? <>
              <p className="text-lg font-semibold text-primary">{tier.name}{price !== null && <span className="font-normal"> · {price} € / mois</span>}</p>
              <p className="mt-1 text-caption text-muted-foreground">{capacityLabel(tier)}</p>
              {price !== null && price > 0 && cycle === "annual" && <p className="mt-1 text-caption text-muted-foreground">Facturé {count(price * 12)} € par an</p>}
            </> : <p className="text-sm text-foreground">Renseignez au moins un utilisateur et un nombre entier de factures, à partir de zéro.</p>}
            </div>
          </div>
          {tier && <Link to={`/tarifs#offre-${tier.id}`} className="group mt-1 inline-flex min-h-11 cursor-pointer items-center gap-2 rounded-sm text-sm font-semibold text-action underline underline-offset-4 hover:text-action-strong focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring">Voir l’offre {tier.name}<ArrowRight aria-hidden className="size-4 transition-transform duration-150 group-hover:translate-x-0.5 motion-reduce:transform-none" /></Link>}
        </div>
      </div>
    </section>
  );
}
